import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m14.38 20.749 1.55-.001h1.053c1.368-.01 2.544-.468 3.377-1.334.831-.863 1.253-2.06 1.253-3.418V8.004c0-1.365-.425-2.567-1.262-3.432-.788-.813-1.88-1.264-3.149-1.317l-.256-.005h-.566l-.477.001H14.38v1.5h2.001l.28-.001h.285c1.042 0 1.814.337 2.328.866.515.533.84 1.333.84 2.388v7.992c0 1.049-.322 1.846-.834 2.378-.509.53-1.275.867-2.306.873h-.237l-2.357.002zm0-4.289h2.4a.75.75 0 0 0 0-1.5h-2.4zm0-3.639h2.4a.75.75 0 0 0 0-1.5h-2.4zm0-3.63h2.373a.75.75 0 0 0 0-1.5H14.38z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M12.757 3.031a.75.75 0 0 1 .873.74V20.23a.75.75 0 0 1-.873.739l-9-1.5a.75.75 0 0 1-.627-.74V5.272a.75.75 0 0 1 .627-.74z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": ".4",
      d: "M10.384 9.017q.204 0 .346.152.15.153.15.323a.48.48 0 0 1-.115.305l-1.779 2.245-.602-.788 1.567-1.991q.186-.246.433-.246ZM6.438 9q.256 0 .433.22l3.894 4.958q.105.136.106.313a.44.44 0 0 1-.177.373.58.58 0 0 1-.354.136.54.54 0 0 1-.433-.22L6.013 9.822a.46.46 0 0 1-.115-.305.46.46 0 0 1 .168-.364A.56.56 0 0 1 6.438 9Zm-.08 6a.47.47 0 0 1-.336-.136.44.44 0 0 1-.142-.313q0-.186.133-.348l1.796-2.33.584.822L6.8 14.763a.53.53 0 0 1-.442.237Z"
    }, null, -1)
  ]))]))
}
export default { render: render }